import Vue from"vue";Vue.filter("propertyFileUrl",(function(r){return App.propertyFileUrl+r}));